import React from "react";
import { ReactComponent as LogoSVG } from "../../assets/images/logo_white.svg";
import Links from "./Links";
import Social from "./Social";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import {
  QUICK,
  QUICK_LINKS,
  QUICK_LINKS_2,
  COMPANY,
  COMPANY_LINKS,
  COMPANY_LINKS_2,
  FOOTER_LINK_BOTTOM,
  TRADE,
  TRADE_LINKS,
  TRADE_FINANCE,
  TRADE_FINANCE_LINKS,
  TRADE_RISK,
  TRADE_RISK_LINKS,
} from "../../constants/constants";
import TorchEffect from "../torchEffect/TorchEffect";

const Footer = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const isPrompt = location.pathname.includes("prompt")
  const { isLoggedIn } = useSelector((state) => state.auth);

  const linksToDisplay = isLoggedIn
    ? COMPANY_LINKS_2.filter((link) => link.text !== "Sign Up")
    : COMPANY_LINKS_2.filter((link) => link.text !== "Dashboard");


  const linksToDisplay1 = isLoggedIn
    ? COMPANY_LINKS.filter((link) => link.text !== "Sign Up")
    : COMPANY_LINKS.filter((link) => link.text !== "Dashboard");

  const handleNavigate = () => {
    window.scrollTo(0, 0);
    localStorage.setItem("fromFooter", true);
    localStorage.removeItem("UpgradePlan");
    localStorage.removeItem("payasyougoCompanyID");
  };

  // Routes that exist in THIS app navigate in-place; everything else is a
  // marketing page on trevex.io and opens in a new tab. TIP-647 added
  // /membership here — without it the footer's "Plans" link would leave the app.
  const IN_APP_PATHS = ["/plans", "/membership"];

  const handleClaimNowClick = (link) => {
    if(IN_APP_PATHS.includes(link?.url)){
      navigate(link.url)
    }else if(link){
      const url = `https://trevex.io${link.url}`
      window.open(url, '_blank');
    }else{
      return null;
    }
    // window.scrollTo(0, 0);
  };

  return (
    <TorchEffect style={{backgroundColor: "rgba(0,0,0,0.4)", width:"100%"}} autoHeight={true}>
    <footer className="pb-0 md:pt-12 ">
      <div className="mx-auto w-full p-4 py-6 lg:py-8 max-w-7xl">
        <div className="md:flex md:justify-between">
          <div className="h-[50px] flex flex-row md:flex-col items-center sm:items-start justify-between sm:gap-5 mb-10 md:mb-0">
            <Link to="/" className="flex items-center">
              <LogoSVG className='w-[80%] sm:w-full' />
            </Link>
            <Social />
          </div>
          <div className="flex flex-wrap flex-col sm:flex-row justify-start gap-10 sm:gap-4 mt-5 sm:mt-0">
            <div className="min-w-[200px] md:px-5">
              <h2 className="mb-6 text-left text-sm font-semibold tracking-wide text-slate text-f18 ">
                {QUICK}
              </h2>
              <div className="text-f16 text-left text-offSlate ">
                <Links links={QUICK_LINKS} onClick={handleClaimNowClick} onNewTab={true} />
              </div>
            </div>
            <div className="min-w-[200px] md:px-5">
              <h2 className="mb-6 text-left text-sm font-semibold tracking-wide text-slate text-f18 ">
                {TRADE}
              </h2>
              <div className="text-f16 text-left text-offSlate ">
                <Links links={TRADE_LINKS} onClick={handleClaimNowClick} onNewTab={true} />
              </div>
            </div>
            <div className="min-w-[200px] md:px-5">
              <h2 className="mb-6 text-left text-sm font-semibold tracking-wide text-slate text-f18 ">
                {TRADE_FINANCE}
              </h2>
              <div className="text-f16 text-left text-offSlate ">
                <Links links={TRADE_FINANCE_LINKS} onClick={handleClaimNowClick} onNewTab={true} />
              </div>
            </div>
            <div className="min-w-[200px] md:px-5">
              <h2 className="mb-6 text-left text-sm font-semibold tracking-wide text-slate text-f18 ">
                {TRADE_RISK}
              </h2>
              <div className="text-f16 text-left text-offSlate ">
                <Links links={TRADE_RISK_LINKS} onClick={handleClaimNowClick} onNewTab={true} />
              </div>
            </div>
          </div>
        </div>
        
      </div>
      <div className="flex bg-[#001F36] p-4 w-full">
            <div className="text-white items-center flex w-full max-w-7xl flex-col gap-2 md: gap-0 md:flex-row justify-center md:justify-between mx-auto">
              <div className="w-full md:text-left text-[#aec0cc] text-[14px] sm:text-[16px]">
                {`Copyright @ ${new Date().getFullYear() -2} - ${new Date().getFullYear()} TREVEX Technology Limited`}
              </div>
              <div className="flex w-full justify-center md:justify-end items-center gap-3 text-[14px] sm:text-[18px] text-[#ebf0f3]">
                <p className="cursor-pointer" onClick={()=>handleClaimNowClick({url:'/privacy-policy'})}>Privacy Policy</p>
                <div className="bg-[#ebf0f3] w-[1px] h-[10px]"></div>
                <p className="cursor-pointer" onClick={()=>handleClaimNowClick({url:'/terms-and-conditions'})}>Terms & Conditions</p>
              </div>
            </div>
        </div>
    </footer>
    </TorchEffect>
  );
};

export default Footer;
